import { useMemo } from 'react'
import AssetEditPage, { AssetPayloadConfig } from '../asset/AssetEditPage'
import { KindEditPageProps } from '../KindPages'

const SEED = `target: app
root: main-shell
components:
  - name: main-shell
    plugin: 0b0e5b9a-0000-4a00-8000-000000000000 # Shell
`

const ConfigurationEditPage = (props: KindEditPageProps) => {
  const config = useMemo<AssetPayloadConfig>(
    () => ({
      payloadLabel: 'Configuration',
      payloadExtension: 'yaml',
      payloadMimeType: 'application/yaml',
      payloadLanguage: 'yaml',
      seedContent: async () => SEED,
      hidePreview: true,
    }),
    []
  )

  return <AssetEditPage {...props} config={config} />
}

export default ConfigurationEditPage
